import React from 'react';
import PropTypes from 'prop-types';
import styles from './ExternalPaymentMethodIcon.scss';

export default function ExternalPaymentMethodIcon({ alt, svgUrl }) {
  return (
    <div className={styles.wrapper}>
      <img className={styles.image} src={svgUrl} alt={alt} width={120} height={60} />
    </div>
  );
}

ExternalPaymentMethodIcon.displayName = 'ExternalPaymentMethodIcon';

ExternalPaymentMethodIcon.propTypes = {
  svgUrl: PropTypes.string,
  alt: PropTypes.string,
};
